// ======================================================================
// File Name       : MultiLanguageResultList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Row, Table, Form } from 'react-bootstrap';
import { parseDateForDetail } from '../../utils';
import { changeMultiLanguageProcessResultStatus, changeMultiLanguageProcessStatus } from '../../utils/ContentUtils';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { MULTI_LANGUAGE_PROCESS_DETAIL } from '../../constants/PathConstants';

class MultiLanguageResultList extends React.Component {

  render() {
    const {
      multiLanguageProcessResultList,
      getStartEndData,
      goToDetail,
      handleMouseEnter,
      handleMouseLeave,
    } = this.props;
    const { recordNum, allProcessIds, byProcessId } = multiLanguageProcessResultList;
    let tbody = null;

    const thead = [
      { title: '処理ID', sortBy: null, width: 250 },
      { title: 'コンテンツ名', sortBy: null },
      { title: '処理種別', sortBy: null, width: 180 },
      { title: '処理開始日時', sortBy: null, width: 180 },
      { title: '処理結果', sortBy: null, width: 165 },
      { title: '操作', sortBy: null, width: 130 },
    ];

    if (allProcessIds && allProcessIds.length > 0) {
      tbody = allProcessIds.map((processId, index) => {
        const multiLang = byProcessId[processId];
        const {
          multiLanguageProcessManagementIdAuto,
          contentName,
          processStartTime,
          processStatus,
          processType,
        } = multiLang;
        const link = MULTI_LANGUAGE_PROCESS_DETAIL.replace(':id', multiLanguageProcessManagementIdAuto);
        return (
          <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={() => handleMouseLeave()}>
            <td>{multiLanguageProcessManagementIdAuto}</td>
            <td><span className="display-ellipsis" style={{ width: '100%' }}>{contentName}</span></td>
            <td>{changeMultiLanguageProcessResultStatus(processType)}</td>
            <td>{parseDateForDetail(processStartTime)}</td>
            <td>{changeMultiLanguageProcessStatus(processStatus)}</td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Form.Group>
          <Col sm={12} className="float-end padding-left-right-clear align-right margin-bottom-10">
            <CustomLink
              className="margin-right-7 btn btn-rotate inline-flex"
              icon={ICON.ROTATE}
              text="更新"
              onClick={this.props.updateData}
            />
          </Col>
        </Form.Group>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="startPosition"
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Row>
          <Col sm={12} className="d-flex justify-content-center">
            <ReduxFormPaging
              className="margin-clear"
              type="paging"
              name="startPosition"
              recordNum={recordNum}
              getStartEndData={getStartEndData}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default MultiLanguageResultList;
